import { render, staticRenderFns } from "./pcmanage.vue?vue&type=template&id=a7c20fc0&"
import script from "./pcmanage.vue?vue&type=script&lang=js&"
export * from "./pcmanage.vue?vue&type=script&lang=js&"
import style0 from "./pcmanage.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports